/**
 * Get the appropriate className for tab item sizing based on configuration
 * @param tabItemSize - The tab item size configuration value
 * @returns The corresponding Tailwind className
 */
export function getTabItemSizingClassName(tabItemSize: string): string {
  switch (tabItemSize) {
    case 'dynamic':
      return 'tab-item-dynamic';
    case 'fixed':
      return 'tab-item-fixed';
    case 'fill':
      return 'tab-item-fill';
    default:
      return 'tab-item-dynamic'; // Default fallback
  }
}

/**
 * Get the appropriate className for tab container based on configuration
 * @param tabItemSize - The tab item size configuration value
 * @returns The corresponding container Tailwind className
 */
export function getTabItemsContainerClassName(tabItemSize: string): string {
  switch (tabItemSize) {
    case 'dynamic':
      return 'tab-container-dynamic';
    case 'fixed':
      return 'tab-container-fixed';
    case 'fill':
      return 'tab-container-fill';
    default:
      return 'tab-container-dynamic'; // Default fallback
  }
}

/**
 * Get the appropriate className for tab items alignment based on configuration
 * @param tabItemAlignment - The tab item alignment configuration value
 * @returns The corresponding alignment Tailwind className
 */
export function getTabItemsAlignmentClassName(
  tabItemAlignment: string
): string {
  switch (tabItemAlignment) {
    case 'left':
      return 'tab-items-left';
    case 'center':
      return 'tab-items-center';
    case 'right':
      return 'tab-items-right';
    default:
      return 'tab-items-left'; // Default fallback
  }
}

export function getTabItemInnerAlignmentClassName(
  tabItemInnerAlignment: string
): string {
  switch (tabItemInnerAlignment) {
    case 'left':
      return 'tab-item-inner-left';
    case 'center':
      return 'tab-item-inner-center';
    case 'right':
      return 'tab-item-inner-right';
    default:
      return 'tab-item-inner-center'; // Default fallback
  }
}

export function getBorderStyleClassName(
  property: string,
  borderStyle: string
): string {
  switch (borderStyle) {
    case 'all':
      return `${property}-all`;
    case 'top':
      return `${property}-top`;
    case 'bottom':
      return `${property}-bottom`;
    default:
      return `${property}-bottom`;
  }
}
